<template>
	<component
		:is="templateType"
		:group="group"
		:changeGroupProductSelection="changeGroupProductSelection"
		:changeSubGroupProductSelection="changeSubGroupProductSelection"
		:changeConfigSelection="changeConfigSelection"
		:isMenu="isMenu"
		:productSelections="productSelections"
		:productSelection="productSelection"
		:index="index"
		:showPrice="showPrice"
		:mainGroup="mainGroup"
		:subProduct="subProduct"
		:additionsProductNotSelected="additionsProductNotSelected"
		:rootProduct="rootProduct"
		:isSingleMenuPage="isSingleMenuPage"
	>
	</component>
</template>

<script>
	import SwitchesGroup from "./GroupTemplates/SwitchesGroup-gt3";
	import CheckboxGroup from "./GroupTemplates/CheckboxGroup-gt3";
	import AmountGroup from "./GroupTemplates/AmountGroup-gt3";

	export default {
		name: "ProductGroupGrid-gt3",
		props: [
			"group",
			"changeGroupProductSelection",
			"changeConfigSelection",
			"productSelections",
			"productSelection",
			"index",
			"changeSubGroupProductSelection",
			"showPrice",
			"isMenu",
			"mainGroup",
			"subProduct",
			"highlightedUpsellProducts",
			"additionsProductNotSelected",
			"rootProduct",
			"isSingleMenuPage"],
		components: {
			SwitchesGroup,
			CheckboxGroup,
			AmountGroup
		},
		computed: {
			templateType() {
				const self = this;
				if(self.group.appearance === "checklist" && self.group.options.allowMultipleSelection) {
					return "checkbox-group";
				} else if(self.group.appearance === "checklist") {
					return "switches-group";
				} else if(self.group.appearance === "amount") {
					return "amount-group";
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.container {
		padding: 4px;
	}
	.flex {
		text-align: center;
		position: relative;
		.v-card {
			background-color: transparent;
		}
	}
	.container.grid-list-sm .layout .flex {
		z-index: 1;
	}
	.layout.wrap {
		padding: 32px 10px 16px 0;
	}
	.accent--text {
		color: #ffc627 !important;
	}

	.background-surface-top {
		position: absolute;
		top: 0;
		width: 100%;
		height: 30%;
		pointer-events: none;
		-webkit-touch-callout: none;
		touch-action: none;
		-webkit-user-select: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			pointer-events: none;
			-webkit-touch-callout: none;
			touch-action: none;
			-webkit-user-select: none;
			user-select: none;
		}
	}

	.background-surface-bottom {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 30%;
		transform: rotate(180deg);
		pointer-events: none;
		-webkit-touch-callout: none;
		touch-action: none;
		-webkit-user-select: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			-webkit-touch-callout: none;
			touch-action: none;
			pointer-events: none;
			-webkit-user-select: none;
			user-select: none;
		}
	}
	.sub-product-wrapper {
		text-align: left;
		padding: 0 0 0 10px;
		.sub-product-content {
			display: inline-block;
			padding-left: 0;
			width: 76%;
			font-size: 16px;
		}
		.checked-text {
			font-size: 15px;

		}
		.v-input--checkbox {
			display: inline-block;
			width: 10%;
			text-align: left;
			position: absolute;
			bottom: 15px;
			right: 7.5px;
			/deep/ .v-icon {
				font-size: 36px !important;
				width: 22px;
			}
		}
	}
</style>
